import styled from '@emotion/styled';

const Section = styled.section`
	padding: 2rem 1.5rem 4rem;
	background: #f3f4f6;
`;

const Inner = styled.div`
	max-width: 60rem;
	margin: 0 auto;
`;

const Body = styled.div`
	font-size: 1.5rem;
	line-height: 2.4rem;
	font-weight: 300;
`;

export default function WysiwygBlockEpsilon({ description }: { description: string }) {
	return (
		<Section id="overview">
			<Inner>
				<Body>{description}</Body>
			</Inner>
		</Section>
	);
}
